import { useState } from 'react';
import BottomSheet from '../BottomSheet';
import * as S from './styles';
import { ChevronDownIcon } from '../../../assets/icons/ChevronDownIcon';
import CheckIcon from '../../../assets/icons/CheckIcon';

export interface SelectOption {
  value: string;
  label: string;
}

interface MobileMultipleSelectProps {
  options: SelectOption[];
  values: string[];
  onChange: (value: string[]) => void;
  title?: string;
}

export const MobileMultipleSelect = ({
  options,
  values: value,
  onChange,
  title = 'Select an option',
}: MobileMultipleSelectProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const handleSelect = (optionValue: string) => {
    if (value.includes(optionValue)) {
      onChange(value.filter((v) => v !== optionValue));
    } else {
      onChange([...value, optionValue]);
    }
  };

  return (
    <>
      <S.SelectButton onClick={handleOpen}>
        <span className="line-clamp-1">{title}</span>
        <span>
          <ChevronDownIcon />
        </span>
      </S.SelectButton>

      <BottomSheet isOpen={isOpen} onClose={handleClose} title={title}>
        <S.MultipleOptionList>
          {options.map((option) => (
            <S.MultipleOptionItem
              key={option.value}
              isSelected={value.includes(option.value)}
              onClick={() => handleSelect(option.value)}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                color: '#737373',
                fontSize: '14px',
                fontWeight: '400',
              }}
            >
              <S.MultipleOptionLabel>{option.label}</S.MultipleOptionLabel>
              <S.MultipleOptionCheckbox checked={value.includes(option.value)}>
                {value.includes(option.value) && <CheckIcon />}
              </S.MultipleOptionCheckbox>
            </S.MultipleOptionItem>
          ))}
        </S.MultipleOptionList>
      </BottomSheet>
    </>
  );
};
